import { FavoritesState } from "~/types/store/favorites";

const state: () => FavoritesState = () => ({
    checkWorker: null,
    checkOffers: new Map(),
});

export default state;
